import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { setLegalRepresentativeCreateRequestField, setLegalRepresentativeUpdateRequestField } from "../../../../pages/clienti/feature/legalRepresentative/slice";
import TextArea from "../../textArea/TextArea";

interface Props {
  mode: "create" | "edit"
}

export function RappLegaleNote({ mode }: Props) {
  const dispatch = useAppDispatch()
  const legalRapresentativeState = useAppSelector(state => state.legalRapresentative)

  const legalRepresentativeRequest = mode === "create" ? legalRapresentativeState.legalRepresentativeCreateRequest : legalRapresentativeState.legalRepresentativeUpdateRequest

  return (
    <div className="flex flex-col gap-2">
      <TextArea
        label="Note"
        defaultValue={legalRepresentativeRequest.note}
        onChangeText={(text) => {
          if (mode === "create")
            dispatch(setLegalRepresentativeCreateRequestField({ field: "note", value: text }))
          else
            dispatch(setLegalRepresentativeUpdateRequestField({ field: "note", value: text }))
        }}
      />
    </div>
  )
}